import { render, staticRenderFns } from "./HowToSearchPopup.vue?vue&type=template&id=65ef39f4&scoped=true&"
import script from "./HowToSearchPopup.vue?vue&type=script&lang=js&"
export * from "./HowToSearchPopup.vue?vue&type=script&lang=js&"
import style0 from "./HowToSearchPopup.vue?vue&type=style&index=0&id=65ef39f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef39f4",
  null
  
)

export default component.exports